import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  const reasons = [
    {
      number: '01',
      title: '実務で全て回した経験',
      description: '営業・採用・育成・組織設計を全て実務レベルで経験。理論だけでなく、現場で直面する課題と解決策を熟知しています。',
      highlights: [
        '年間50名以上のエンジニア採用',
        'SES/受託営業で年間売上1.2億円',
        'オンボーディング〜評価制度まで設計・運用'
      ]
    },
    {
      number: '02',
      title: '経営者目線での横断支援',
      description: '採用だけ、営業だけではなく、経営者が本当に困っている「複数領域を同時に回す」課題を理解し、一気通貫でサポートします。',
      highlights: [
        '採用〜配置〜定着まで一貫対応',
        '営業〜顧客管理〜売上創出',
        '組織課題の早期発見と改善提案'
      ]
    },
    {
      number: '03',
      title: 'スピード感のある実行力',
      description: '大手企業の経験ではなく、ベンチャーで鍛えた「即実行・即改善」のスピード感。経営者の時間を無駄にしません。',
      highlights: [
        '即日対応可能な柔軟性',
        '実務レベルの提案と実行',
        '結果にコミットする姿勢'
      ]
    }
  ];

  return (
    <section id="why-us" className="why-us">
      <div className="container">
        <div className="why-us__header animate-on-scroll">
          <h2 className="why-us__title">
            選ばれる理由
          </h2>
          <p className="why-us__subtitle">
            なぜ中小IT企業の経営者に選ばれるのか
          </p>
        </div>

        <div className="why-us__list">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="why-us__card animate-on-scroll"
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              <div className="why-us__card-number">{reason.number}</div>
              
              <div className="why-us__card-content">
                <h3 className="why-us__card-title">{reason.title}</h3>
                <p className="why-us__card-description">{reason.description}</p>
                
                <ul className="why-us__card-highlights">
                  {reason.highlights.map((highlight, idx) => (
                    <li key={idx} className="why-us__card-highlight">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 13L9 17L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="why-us__card-decoration"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;

